const SCROLL_OPTIONS = { behavior: "smooth", block: "center" };

export default {
    data() {
        return {
            investmentAreasCollapsed: false,
            investmentAreasCollapsedS: false,
            investmentAreasPowiatyCollapsed: {},
            investmentAreasPowiatyCollapsedS: {},
            investmentAreasGminyCollapsed: {},
            investmentAreasGminyCollapsedS: {},
            investmentAreasArrayS: [],
        }
    },
    methods: {
        selectOferta({ id }) {
            this.setCurrentOferta(this.$store.getters['tereny/getById'](id))
        },
        selectOfertaS({ id }) {
            this.setCurrentOferta(this.$store.getters['inwestorzy/getById'](id))
        },
        clearCollapse() {
            this.$store.dispatch("showList", {})
        }
    },
    mounted() {
        this.$root.$on("cartogramSelectPowiat", selected_powiat => {
            let powiat_obj = this.$store.getters["jst/powiaty"].find(
                p => p.nazwa === selected_powiat
            );
            let listType = this.$store.getters.listType;
            // console.log("nav", {...this.$store.getters.nav});
            this.$store.dispatch("selectPowiat", {
                powiat: powiat_obj,
            });

            if (listType) {
                let eid = `list-jst-${listType}-district-${powiat_obj.id}`;
                document.getElementById(eid).scrollIntoView(SCROLL_OPTIONS);
            } else {
                window.setTimeout(() => {
                    let listType = this.$store.getters.listType;
                    let eid = `list-jst-${listType}-district-${powiat_obj.id}`;
                    document.getElementById(eid).scrollIntoView(SCROLL_OPTIONS);
                }, 2000)
            }
        })
        this.$root.$on("cartogramSelectGmina", ({ gmina }) => {
            let gmina_obj = this.$store.getters["jst/gminy"].find(
                g => g.nazwa === gmina
            );
            this.$store.dispatch("selectGmina", {
                gmina: gmina_obj,
            });
            let listType = this.$store.getters.listType;
            let eid = `list-jst-${listType}-community-${gmina_obj.id}`;
            document.getElementById(eid).scrollIntoView(SCROLL_OPTIONS);
        })
        this.$root.$on("cartogramSelectOferta", data => {
            this.selectOferta(data);
        })
        this.$root.$on("cartogramClearCollapse", () => {
            this.clearCollapse();
        })
        this.$root.$on("cartogramSelectOfertaS", data => {
            this.selectOfertaS(data);
        })
    }
}